import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AddLeadsForm from './AddLeadsForm';
import Leads from './Leads';
import EditLeads from './EditLeads';

function MyLeads() {
  const [clients, setClients] = useState([]);
  const [showAddClientForm, setShowAddClientForm] = useState(false);
  const [editClientData, setEditClientData] = useState(null);
  const [showEditClientForm, setShowEditClientForm] = useState(false);

  useEffect(() => {
    getClients();
  }, []);

  const getClients = async () => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/Leads`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      setClients(res.data);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
  };

  const openEditClientForm = (client) => {
    setEditClientData(client);
    setShowEditClientForm(true);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold mb-4 text-white">Leads</h1>

      <button
        onClick={() => setShowAddClientForm(!showAddClientForm)}
        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition mb-4"
      >
        {showAddClientForm ? "Close Form" : "Add Leads"}
      </button>

      {showAddClientForm && (
      
        <AddLeadsForm closeModal={() => setShowAddClientForm(false)} onLeadsUpdated={getClients} />
      )}

      <Leads clients={clients} onClientDeleted={getClients} openEditClientForm={openEditClientForm} />

      {showEditClientForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded shadow-lg w-full max-w-xl p-6">
  
              <EditLeads client={editClientData} closeModal={() => setShowEditClientForm(false)} onLeadsUpdated={getClients} />
          </div>
        </div>
      )}
    </div>
  );
}

export default MyLeads;
